export const IntersectionObserver = window.IntersectionObserver